// Central date formatting for EQUIPR Intelligence.
// All calendar dates are shown as dd-MM-YYYY; timestamps as dd-MM-YYYY HH:mm (24h).
// Defaults to Brisbane (AEST) since the whole product operates in that timezone.
const TZ = "Australia/Brisbane";

function _toDate(v) {
  if (!v) return null;
  const d = v instanceof Date ? v : new Date(v);
  return isNaN(d.getTime()) ? null : d;
}

// dd-MM-YYYY (empty string for missing/invalid input)
export function formatDate(v, tz = TZ) {
  const d = _toDate(v);
  if (!d) return "";
  return new Intl.DateTimeFormat("en-GB", {
    timeZone: tz, day: "2-digit", month: "2-digit", year: "numeric",
  }).format(d).replace(/\//g, "-");
}

// dd-MMM-YYYY (e.g. 12-Jun-2026) — short month name
export function formatDateMed(v, tz = TZ) {
  const d = _toDate(v);
  if (!d) return "";
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: tz, day: "2-digit", month: "short", year: "numeric",
  }).formatToParts(d);
  const g = (t) => parts.find((p) => p.type === t)?.value || "";
  return `${g("day")}-${g("month")}-${g("year")}`;
}

// dd-MM-YYYY HH:mm (24-hour)
export function formatDateTime(v, tz = TZ) {
  const d = _toDate(v);
  if (!d) return "";
  const parts = new Intl.DateTimeFormat("en-GB", {
    timeZone: tz, day: "2-digit", month: "2-digit", year: "numeric",
    hour: "2-digit", minute: "2-digit", hour12: false,
  }).formatToParts(d);
  const g = (t) => parts.find((p) => p.type === t)?.value || "";
  return `${g("day")}-${g("month")}-${g("year")} ${g("hour")}:${g("minute")}`;
}
